import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { generateUUID } from 'projects/processo-custom-table/src/usecase';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'lib-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailComponent implements DoCheck {
  @HostBinding('attr.unique-id')
  uniqueId = `${generateUUID()}`;
  @Input() parent: any;
  @Input() innerTable: any;
  @Input() header: any;
  @Input() data: any;
  @Input() i: any;
  editval$: any;
  editval = new BehaviorSubject<boolean>(false);
  constructor(private cdr: ChangeDetectorRef) {
    this.editval$ = this.editval;
  }
  ngDoCheck(): void {
    if(this.header?.callUniqueApi && this.editval.getValue()){
      
      this.checkValidation({target:{value:this.data[this.header.name]}})
    }
    this.cdr.markForCheck();    
  }
  editing() {
    if(!this.header.can_edit || this.header.tab_name==='XX' || this.data?.is_locked || this.data?.lock_fields?.includes(this.header?.name)){
      return
    }
    if (this.editval.getValue()) {
      this.editval.next(false);
    } else {
      this.editval.next(true);
    }
    this.cdr.markForCheck();
  }
  checkValidation(e: any) {
    this.header.error = this.showEmailError(this.header, e.target.value);
    if (this.header.datatype === 'email' && this.header.is_unique) {
      this.header.callUniqueApi = false
      let filterData: any = {};
      let body: any = {
        org_id: this.parent.pservice.appState().selectedOrganization.org_id,
        process_id: this.parent.pservice.appState().selectedProcess.process_id,
        process_name:
          this.parent.pservice.appState().selectedProcess.process_name?.replace(/\s/g, '_'),
        entity_name: this.parent.pservice.appState()?.selectedEntity,
        // filter: {
        //   [this.header.name]: this.data[this.header.name],
        // },
        entity_id: this.data?.entity_id,
      };
      filterData[this.header.name] = this.data[this.header.name];
      let data = this.header?.unique_fn?.map((fieldName: any) => {
        if (fieldName) {
          filterData[fieldName] = this.data[fieldName];
        }
      });
      body['filter'] = filterData;
      this.parent.pservice.fetchEntityDataUnique(body).subscribe((res: any) => {
        if (res.exists) {
          this.header.error = `${this.header.label} value already exists`;
          this.cdr.detectChanges();
          return;
        } else {
          let field = this.parent.getTableHeaders()
          let data = this.header?.unique_fn?.map((fieldName: any) => {
            if (fieldName) {
              field.map((_e:any)=>{
                if (_e?.name === fieldName) {
                  _e.callUniqueApi=true                    
                  _e.error = '';
                
                  
                }
              })
            }
          });
          
          this.header.error = '';
          this.saveData(e);
          this.cdr.detectChanges();
        }
      });
    } else {
      this.saveData(e);
    }
  }
  error = '';
 check_is_unique(e: any) {
   let filterData: any = {};
   let body: any = {
     org_id: this.parent.pservice.appState().selectedOrganization.org_id,
     process_id: this.parent.pservice.appState().selectedProcess.process_id,
     process_name: this.parent.pservice
       .appState()
       .selectedProcess.process_name?.replace(/\s/g, '_'),
     entity_name: this.parent.pservice.appState()?.selectedEntity,
     entity_id: this.data?.entity_id,
   };
   if (this.header.is_unique && this.header.unq_sa) {
     filterData[this.header?.name] = this.data[this.header?.name];
   } else if (this.header.is_unique && !this.header.unq_sa) {
     let total_field = this.parent.pservice
       .appState()
       ?.metaData?.entities?.find(
         (_e: any) =>
           _e.name === this.parent.pservice.appState()?.selectedEntity
       )?.fields;
     total_field.forEach((_fields: any) => {
       if (_fields.is_unique && !_fields.unq_sa) {
         filterData[_fields?.name] = this.data[_fields?.name];
       }
     });
   }
   body['filter'] = filterData;
   if(this.header.is_unique){
     this.parent.pservice.fetchEntityDataUnique(body).subscribe({
       next: (res: any) => {
         if (res) {
           if (res.exists) {
             this.error = `${this.header.label} value already exists`;
           } else {
             this.error = '';
             setTimeout(() => {
              if (this.error?.length === 0 || this.error === '') {
               this.saveData(e);
              }
            }, 100);
           }
           this.cdr.detectChanges();
         }
       },
       complete: () => {

       },
     });
   }else{
     setTimeout(() => {
       if (this.error?.length === 0 || this.error === '') {
        this.saveData(e);
       }
     }, 100);
   }

 }
  saveData(e: any) {
    if (!this.header.error) {
      let tableEdit: any;
      if (this.innerTable) {
        tableEdit = 'innerTable';

        this.parent.updateDataOnInnerStopEdit(e, this.header.name, this.data);
        this.editval.next(false);
      } else {
        this.parent.updateDataOnStopEdit(
          e,
          this.header.name,
          this.data,
          this.parent.erulistData
        );
        this.editval.next(false);
      }
      this.parent.saveEntityDropdownData(this.header, tableEdit, this.data);
    }
  }
  showEmailError(field: any, email: string) {
    if (field.mandatory && !email) {
      return '';
    }
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !emailPattern.test(email) ? 'Invalid Email' : '';
  }
}
